import React, { useState } from 'react';
import styles from './LandingPage2.module.css';

const LandingPage2 = () => {
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const faqItems = [
    "Is AutoChef actually going to save me money on groceries?",
    "Will this help me track a successful meal planning system?",
    "Do I have to commit to specific day plan cooking?",
    "Can I make the meal plan work for my family?",
    "Will I'll help me avoid cooking the same three meals every week?",
    "What if I don't know how to cook complicated meals?",
    "Is recipe going to take forever?"
  ];

  const testimonials = [
    {
      text: "I'm so happy we don't have to discuss what's for dinner every night!",
      author: "Jordan J, parent"
    },
    {
      text: "We no longer spend an entire day meal planning",
      author: "Sarah M, parent"
    },
    {
      text: "I'm so happy we don't have to discuss what's for dinner every night!",
      author: "Michael K, parent"
    }
  ];

  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          <div className={styles.heroLeft}>
            <h1 className={styles.heroTitle}>Eat Better, Stress Less</h1>
            <img 
              src="icons/byte.png" 
              alt="AutoChef Robot" 
              className={styles.heroRobot}
            />
            <p className={styles.heroSubtext}>
              Personalized Meal Planning.<br />
              because you've got better things to do<br />
              than think about what's for dinner
            </p>
            <button className={styles.primaryButton}>Sign Up Now</button>
          </div>
          <div className={styles.heroRight}>
            <div className={styles.featureBox}>
              <img src="/images/HandHoldingiPhone.svg" alt="Meal Planning" />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className={styles.benefitsSection}>
        <div className={styles.benefitsGrid}>
          <div className={styles.benefitCard}>
            <div className={styles.benefitPlaceholder}>
              Screen Shot About<br />Less Work
            </div>
            <h3 className={styles.benefitTitle}>Save Time</h3>
          </div>
          <div className={styles.benefitCard}>
            <div className={styles.benefitPlaceholder}>
              Screen Shot About<br />Meal Prep
            </div>
            <h3 className={styles.benefitTitle}>Save Food</h3>
          </div>
          <div className={styles.benefitCard}>
            <div className={styles.benefitPlaceholder}>
              Screen Shot About<br />Cost Savings
            </div>
            <h3 className={styles.benefitTitle}>and Money</h3>
          </div>
        </div>
        <div className={styles.robotSpeechContainer}>
          <img 
            src="/robot-chef-small.png" 
            alt="AutoChef Robot" 
            className={styles.smallRobot}
          />
          <div className={styles.speechBubble}>
            Yes, really we can do all of that!
          </div>
        </div>
      </section>

      {/* Never Wonder Section */}
      <section className={styles.neverWonderSection}>
        <h2 className={styles.sectionTitle}>Never wonder what to cook again</h2>
        <div className={styles.neverWonderContent}>
          <div className={styles.neverWonderLeft}>
            <img 
              src="/robot-chef.png" 
              alt="AutoChef Robot" 
              className={styles.neverWonderRobot}
            />
            <div className={styles.speechBubbleLeft}>
              Just add ingredients you<br />
              already have and we'll find<br />
              you delicious meals and<br />
              create shopping lists for<br />
              the rest. Do you need any<br />
              prep done? We got that<br />
              handled as well.
            </div>
          </div>
          <div className={styles.neverWonderRight}>
            <div className={styles.featureBox}>
              Screen Shot About<br />Meal Planning food preferences
            </div>
          </div>
        </div>
      </section>

      {/* Grocery Lists Section */}
      <section className={styles.grocerySection}>
        <h2 className={styles.sectionTitleWhite}>Grocery lists that build themselves</h2>
        <div className={styles.groceryContent}>
          <div className={styles.groceryLeft}>
            <div className={styles.featureBoxWhite}>
              Screen Shot about<br />the grocery list
            </div>
          </div>
          <div className={styles.groceryRight}>
            <img 
              src="/robot-chef-small.png" 
              alt="AutoChef Robot" 
              className={styles.smallRobotWhite}
            />
            <div className={styles.speechBubbleWhite}>
              Your grocery list will<br />
              automatically update based<br />
              on the recipes you pick!
            </div>
          </div>
        </div>
      </section>

      {/* Stop Wasting Section */}
      <section className={styles.stopWastingSection}>
        <h2 className={styles.sectionTitle}>Stop wasting food and money!</h2>
        <p className={styles.stopWastingSubtext}>
          Help you use up leftovers, reduce food waste, keep a running grocery list and<br />
          avoid panic pick up on "oh frick, what's for dinner"
        </p>
      </section>

      {/* Testimonials Section */}
      <section className={styles.testimonialsSection}>
        <h2 className={styles.sectionTitle}>What people are saying...</h2>
        <div className={styles.testimonialsGrid}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className={styles.testimonialCard}>
              <div className={styles.stars}>
                {'★'.repeat(5)}
              </div>
              <p className={styles.testimonialText}>"{testimonial.text}"</p>
              <p className={styles.testimonialAuthor}>- {testimonial.author}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ Section */}
      <section className={styles.faqSection}>
        <h2 className={styles.sectionTitle}>FAQ</h2>
        <div className={styles.faqList}>
          {faqItems.map((question, index) => (
            <div key={index} className={styles.faqItem}>
              <button 
                className={styles.faqButton}
                onClick={() => toggleFaq(index)}
              >
                <span>{question}</span>
                <span className={styles.faqIcon}>
                  {openFaqIndex === index ? '−' : '+'}
                </span>
              </button>
              {openFaqIndex === index && (
                <div className={styles.faqAnswer}>
                  <p>Answer content goes here...</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA Section */}
      <section className={styles.finalCtaSection}>
        <h2 className={styles.sectionTitle}>Meal planning without the mental gymnastics</h2>
        <div className={styles.finalCtaContent}>
          <img 
            src="/robot-chef.png" 
            alt="AutoChef Robot" 
            className={styles.finalRobot}
          />
          <div className={styles.speechBubbleRight}>
            It's like having a robot in<br />
            the kitchen!
          </div>
        </div>
        <button className={styles.primaryButton}>Get Started Free</button>
        <p className={styles.finalSubtext}>No credit card required</p>
      </section>
    </div>
  );
};

export default LandingPage2;
